import { useCallback, useMemo } from 'react';
import { AppFilterHelper } from '../../../hooks/filters/helpers/app-filter.helper';
import {
  FilterOptionMatchStrategy,
  FilterSelectedValue,
} from '../../../hooks/filters/interfaces/filter-selected-value.interface';
import {
  useAppFilterSelectedValue,
  useAppSetSelectedValue,
} from '../../../hooks/filters/use-app-filter-selected-value.hook';
import {
  useAppSimpleFilterSelectedValue,
  useFilterSelectionMemo,
  useFullFilterSelectionMemo,
} from './common.hook';
import { FILTER_NAMES } from './filter-names.constants';

// const DRILLTHROUGHT_MAP:Record<string, string> = {
//     [FILTER_NAMES.DATE_DRILLTHROUGH]: FILTER_NAMES.DATE,
//     [FILTER_NAMES.MARKET_DRILLTHROUGH]: FILTER_NAMES.MARKET,
//     [FILTER_NAMES.CATEGORY_DRILLTHROUGH]: FILTER_NAMES.CATEGORY_DRILLDOWN,
//     [FILTER_NAMES.BRAND_DRILLTHROUGH]: FILTER_NAMES.BRAND_DRILLDOWN,
//     [FILTER_NAMES.SUBBRAND_DRILLTHROUGH]: FILTER_NAMES.SUBBRAND_DRILLDOWN,
//     [FILTER_NAMES.SIZEGROUP_DRILLTHROUGH]: FILTER_NAMES.SIZEGROUP_DRILLDOWN,
//     [FILTER_NAMES.PPG_DRILLTHROUGH]: FILTER_NAMES.PPG_DRILLDOWN
// }

export const DRILLTHROUGH_DECOMP_INSIGHTS_MAP: Record<string, string> = {
  [FILTER_NAMES.MARKET]: FILTER_NAMES.MARKETMULTI,
  [FILTER_NAMES.CATEGORY_DRILLDOWN]: FILTER_NAMES.CATEGORY_DRILLTHROUGH,
  [FILTER_NAMES.BRAND_DRILLDOWN]: FILTER_NAMES.BRAND_DRILLTHROUGH,
  [FILTER_NAMES.SUBBRAND_DRILLDOWN]: FILTER_NAMES.SUBBRAND_DRILLTHROUGH,
  [FILTER_NAMES.SIZEGROUP_DRILLDOWN]: FILTER_NAMES.SIZEGROUP_DRILLTHROUGH,
  [FILTER_NAMES.PPG_DRILLDOWN]: FILTER_NAMES.PPG_DRILLTHROUGH,
};
export const DRILLTHROUGH_DECOMP_INSIGHTS_MATCHSTRATEGY_MAP: Record<
  string,
  FilterOptionMatchStrategy
> = {
  [FILTER_NAMES.MARKET]: AppFilterHelper.getMatchStrategyMultiple(),
};
export const DRILLTHROUGH_MAP: Record<string, string> = {
  // [FILTER_NAMES.DATE]: FILTER_NAMES.DATE_DRILLTHROUGH,
  // [FILTER_NAMES.MARKET]: FILTER_NAMES.MARKET_DRILLTHROUGH,
  // [FILTER_NAMES.METACATEGORY]: FILTER_NAMES.METACATEGORY_DRILLTHROUGH,

  [FILTER_NAMES.CATEGORY_DRILLDOWN]: FILTER_NAMES.CATEGORY_DRILLTHROUGH,
  [FILTER_NAMES.BRAND_DRILLDOWN]: FILTER_NAMES.BRAND_DRILLTHROUGH,
  [FILTER_NAMES.SUBBRAND_DRILLDOWN]: FILTER_NAMES.SUBBRAND_DRILLTHROUGH,
  [FILTER_NAMES.SIZEGROUP_DRILLDOWN]: FILTER_NAMES.SIZEGROUP_DRILLTHROUGH,
  [FILTER_NAMES.PPG_DRILLDOWN]: FILTER_NAMES.PPG_DRILLTHROUGH,
};
export const DRILLTHROUGH_FULL_VIEW_MAP: Record<string, string> = {
  // [FILTER_NAMES.DATE]: FILTER_NAMES.DATE_DRILLTHROUGH,
  // [FILTER_NAMES.MARKET]: FILTER_NAMES.MARKET_DRILLTHROUGH,
  // [FILTER_NAMES.METACATEGORY]: FILTER_NAMES.METACATEGORY_DRILLTHROUGH,

  [FILTER_NAMES.COMPACT_VIEW_CATEGORY]: FILTER_NAMES.CATEGORY_DRILLTHROUGH,
  [FILTER_NAMES.COMPACT_VIEW_BRAND]: FILTER_NAMES.BRAND_DRILLTHROUGH,
  [FILTER_NAMES.COMPACT_VIEW_SUBBRAND]: FILTER_NAMES.SUBBRAND_DRILLTHROUGH,
  [FILTER_NAMES.COMPACT_VIEW_SIZEGROUP]: FILTER_NAMES.SIZEGROUP_DRILLTHROUGH,
  [FILTER_NAMES.COMPACT_VIEW_PPG]: FILTER_NAMES.PPG_DRILLTHROUGH,
};
export const useUpdateDrillthrough = (
  drillthroughMap: Record<string, string> = DRILLTHROUGH_MAP,
  drillthroughMatchStrategyMap?: Record<string, FilterOptionMatchStrategy>,
) => {
  // const setDateValue = useAppSetSelectedValue(FILTER_NAMES.DATE_DRILLTHROUGH)
  const setMarketMultiValue = useAppSetSelectedValue(FILTER_NAMES.MARKETMULTI);
  // const setMetacategoryValue = useAppSetSelectedValue(FILTER_NAMES.METACATEGORY_DRILLTHROUGH)
  const setCategoryValue = useAppSetSelectedValue(
    FILTER_NAMES.CATEGORY_DRILLTHROUGH,
  );
  const setBrandValue = useAppSetSelectedValue(FILTER_NAMES.BRAND_DRILLTHROUGH);
  const setSubBrandValue = useAppSetSelectedValue(
    FILTER_NAMES.SUBBRAND_DRILLTHROUGH,
  );
  const setSizeGroupValue = useAppSetSelectedValue(
    FILTER_NAMES.SIZEGROUP_DRILLTHROUGH,
  );
  const setPpgValue = useAppSetSelectedValue(FILTER_NAMES.PPG_DRILLTHROUGH);
  const setFilterSelection: Record<string, any> = useMemo(() => {
    return {
      // [FILTER_NAMES.DATE_DRILLTHROUGH]: setDateValue,
      [FILTER_NAMES.MARKETMULTI]: setMarketMultiValue,
      // [FILTER_NAMES.METACATEGORY_DRILLTHROUGH]: setMetacategoryValue,
      [FILTER_NAMES.CATEGORY_DRILLTHROUGH]: setCategoryValue,
      [FILTER_NAMES.BRAND_DRILLTHROUGH]: setBrandValue,
      [FILTER_NAMES.SUBBRAND_DRILLTHROUGH]: setSubBrandValue,
      [FILTER_NAMES.SIZEGROUP_DRILLTHROUGH]: setSizeGroupValue,
      [FILTER_NAMES.PPG_DRILLTHROUGH]: setPpgValue,
    };
  }, [
    setMarketMultiValue,
    setCategoryValue,
    setBrandValue,
    setSubBrandValue,
    setSizeGroupValue,
    setPpgValue,
  ]);
  const updateDrillthrough = useCallback(
    (filterSelection: FilterSelectedValue[] | undefined) => {
      Object.entries(drillthroughMap).forEach(([key, value]) => {
        if (filterSelection) {
          const filterId = value;
          const setFilterSel = setFilterSelection[filterId];
          const filterSel = filterSelection.find((i) => i.id === key);
          if (filterSel) {
            const matchStrategy =
              drillthroughMatchStrategyMap && drillthroughMatchStrategyMap[key]
                ? drillthroughMatchStrategyMap[key]
                : filterSel.matchStrategy;
            if (setFilterSel) {
              setFilterSel({ ...filterSel, id: filterId, matchStrategy });
            }
          } else {
            if (setFilterSel) {
              setFilterSel({ id: filterId, values: [], mattchStrategy: {} });
            }
          }
        }
      });
    },
    [setFilterSelection, drillthroughMap, drillthroughMatchStrategyMap],
  );

  return updateDrillthrough;
};

export const useFilterDrilltroughSelection = () => {
  // const date = useAppSimpleFilterSelectedValue(FILTER_NAMES.DATE)
  // const market = useAppSimpleFilterSelectedValue(FILTER_NAMES.MARKET)
  // const metaCategory = useAppSimpleFilterSelectedValue(FILTER_NAMES.METACATEGORY)

  const category = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.CATEGORY_DRILLTHROUGH,
  );
  const brand = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.BRAND_DRILLTHROUGH,
  );
  const subBrand = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.SUBBRAND_DRILLTHROUGH,
  );
  const sizeGroup = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.SIZEGROUP_DRILLTHROUGH,
  );
  const ppg = useAppSimpleFilterSelectedValue(FILTER_NAMES.PPG_DRILLTHROUGH);
  // const variable = useAppSimpleFilterSelectedValue(FILTER_NAMES.VARIABLE)
  // const measureHier = useAppSimpleFilterSelectedValue(FILTER_NAMES.MEASUREHIER)
  // const filterMemo = useMemo(() =>
  //     [category, brand, subBrand, sizeGroup, ppg],
  //     [category, brand, subBrand, sizeGroup, ppg],
  // )
  const filterSelection = useFilterSelectionMemo(
    category,
    brand,
    subBrand,
    sizeGroup,
    ppg,
  );
  return filterSelection;
};

export const useIsDrillthrough = () => {
  const filterSelectionDrillthrough = useFilterDrilltroughSelection();
  const ret = useMemo(() => {
    if (filterSelectionDrillthrough && filterSelectionDrillthrough.length > 0) {
      const found = filterSelectionDrillthrough.find(
        (i) => i.values && i.values.length > 0,
      );
      if (found) {
        return true;
      } else {
        return false;
      }
    }
  }, [filterSelectionDrillthrough]);

  return ret;
};

export const useFilterCoefficientSelection = () => {
  const coefficientSelector = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.COEFFICIENTSELECTOR,
  );
  //const dependentVar = useAppSimpleFilterSelectedValue(FILTER_NAMES.DEPENDENTVAR)

  // const filterMemo = useMemo(() =>
  //     [coefficientSelector], //dependentVar],
  //     [coefficientSelector],// dependentVar],
  // )
  const filterSelection = useFilterSelectionMemo(coefficientSelector);
  return filterSelection;
};
export const useFilterVariableAndCompBrandSelection = () => {
  const variable = useAppSimpleFilterSelectedValue(FILTER_NAMES.VARIABLE);
  const compBrand = useAppSimpleFilterSelectedValue(FILTER_NAMES.COMPBRAND);
  //const dependentVar = useAppSimpleFilterSelectedValue(FILTER_NAMES.DEPENDENTVAR)

  // const filterMemo = useMemo(() =>
  //     [variable, compBrand],// dependentVar],
  //     [variable, compBrand],// dependentVar],
  // )
  const filterSelection = useFilterSelectionMemo(variable, compBrand);
  return filterSelection;
};
export const useFilterVariableCompBrandSelection = () => {
  const variableCompBrand = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.VARIABLECOMPBRAND,
  );
  // const filterMemo = useMemo(() =>
  //     [variableCompBrand],
  //     [variableCompBrand],
  // )
  const filterSelection = useFilterSelectionMemo(variableCompBrand);
  return filterSelection;
};
// export const useFilterDependentSelection = () => {
//     const dependentVar = useAppSimpleFilterSelectedValue(FILTER_NAMES.DEPENDENTVAR)
//     const filterSelection = useFilterMemo([dependentVar])
//     return filterSelection
// }

export const useSetFilterDrilltroughSelection = () => {
  // const date = useAppFilterSelectedValue(FILTER_NAMES.DATE_DRILLTHROUGH)
  // const metaCategory = useAppFilterSelectedValue(FILTER_NAMES.METACATEGORY_DRILLTHROUGH)
  // const market = useAppFilterSelectedValue(FILTER_NAMES.MARKET_DRILLTHROUGH)
  const category = useAppFilterSelectedValue(
    FILTER_NAMES.CATEGORY_DRILLTHROUGH,
  );
  const brand = useAppFilterSelectedValue(FILTER_NAMES.BRAND_DRILLTHROUGH);
  const subBrand = useAppFilterSelectedValue(
    FILTER_NAMES.SUBBRAND_DRILLTHROUGH,
  );
  const sizeGroup = useAppFilterSelectedValue(
    FILTER_NAMES.SIZEGROUP_DRILLTHROUGH,
  );
  const ppg = useAppFilterSelectedValue(FILTER_NAMES.PPG_DRILLTHROUGH);
  // const filterMemo = useMemo(() =>
  //     [category, brand, subBrand, sizeGroup, ppg],
  //     [category, brand, subBrand, sizeGroup, ppg],
  // )
  const filterSelection = useFullFilterSelectionMemo(
    category,
    brand,
    subBrand,
    sizeGroup,
    ppg,
  );
  return filterSelection;
};

export const useFilterDataZoomSelection = () => {
  const dateZoom = useAppSimpleFilterSelectedValue(FILTER_NAMES.DATEZOOM);

  // const filterMemo = useMemo(() =>
  //     [dateZoom],
  //     [dateZoom],
  // )
  const filterSelection = useFilterSelectionMemo(dateZoom);
  return filterSelection;
};
